export class EmailConfirmation {
  email: string = "";
  token: string = "";

  constructor() {}
}
